"use strict";

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Contact from './src/contact';

const element = document.getElementById('contactAppEntry');
const props =  Object.assign({}, element.dataset);

render((
    <Router>
        <Contact {...props} />
    </Router>
), element);